import Icon, { type IconString } from '2-core-elements/Icon/Icon';
import { type ChangeEvent, type FocusEvent, type FC } from 'react';

interface RadioTabItemProps {
    className?: string;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
    required?: boolean;
    disabled?: boolean;
    label: string;
    id: string;
    name?: string;
    value?: string | number;
    checked?: boolean;
    icon?: IconString;
    suffixText?: string;
}

const RadioTabItem: FC<RadioTabItemProps> = (props: RadioTabItemProps) => {
    const { icon, suffixText, label = 'RadioButton item', name, value, id, className = '', onChange, required = false, disabled = false, checked, onBlur } = props;

    const classOutput = `radio-tab-item ${className}`;

    return (
        <div className={classOutput}>
            <label htmlFor={id}>
                <input type="radio" id={id} name={name} value={value} required={required} disabled={disabled} onChange={onChange} onBlur={onBlur} checked={checked} />
                <span className="input-label">
                    {icon && (
                        <Icon icon={icon} className="input-label-icon" />
                    )}
                    <span className="input-label-text">{label}</span>
                    {suffixText && (
                        <span className="input-label-suffix">{suffixText}</span>
                    )}
                </span>
            </label>
        </div>
    );
};

export default RadioTabItem;
